import React from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './context/AuthContext';
import { SchemeProvider } from './context/SchemeContext';
import ProtectedRoute from './components/ProtectedRoute';
import AdminLayout from './layouts/AdminLayout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import UploadUsers from './pages/UploadUsers';
import Users from './pages/Users';
import Schemes from './pages/Schemes'; // New Page
import ApiLogs from './pages/ApiLogs';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <SchemeProvider>
          <HashRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route element={<ProtectedRoute />}>
                <Route element={<AdminLayout />}>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/upload" element={<UploadUsers />} />
                  <Route path="/users" element={<Users />} />
                  <Route path="/schemes" element={<Schemes />} /> {/* New Route */}
                  <Route path="/logs" element={<ApiLogs />} />
                </Route>
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </HashRouter>
        </SchemeProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;